import './Dialog-1a61e61a.css';

var classes = {"Backdrop":"prc-Dialog-Backdrop-ugYqZ","Dialog":"prc-Dialog-Dialog-luvDS","DisableScroll":"prc-Dialog-DisableScroll-F6LZa","DialogOverflowWrapper":"prc-Dialog-DialogOverflowWrapper-oDYJo","Footer":"prc-Dialog-Footer-jQfN4","Header":"prc-Dialog-Header-cjbcl","HeaderInner":"prc-Dialog-HeaderInner-eY68M","HeaderContent":"prc-Dialog-HeaderContent-CRaRY","Title":"prc-Dialog-Title-oQ-W6","Subtitle":"prc-Dialog-Subtitle-sITpo","Body":"prc-Dialog-Body-LCvER"};

export { classes as default };
